var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"vl-notify vl-notify-tips",class:[this.options.tips[1],'vl-notify-tips-'+ this.options.tips[0]],attrs:{"id":_vm.options.id},domProps:{"innerHTML":_vm._s(_vm.options.content)}},[_c('em')])}
var staticRenderFns = []

export { render, staticRenderFns }